import { TenantHostname } from "~/api/Api";
import MantineButton from "~/components/mantine/button/Button.tsx";
import { ActionColumn } from "~/components/ui/dataTable/DataTable";

type HostnameActionButtonsProps = {
  openDelete: (id: number) => void;
  isLoading: boolean;
  hostname: TenantHostname;
};

export const HostnameActionButtons = ({
  openDelete,
  isLoading,
  hostname,
}: HostnameActionButtonsProps) => {
  return (
    <ActionColumn>
      {(close) => (
        <MantineButton
          disabled={isLoading}
          onClick={() => {
            close();
            openDelete(hostname.id);
          }}
          variant="menuItem"
        >
          Delete
        </MantineButton>
      )}
    </ActionColumn>
  );
};
